
























import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ExStore } from 'vuex'
import { getEnvVar } from '@/utils'
import { PrivateWorker } from '@/types/user'
import { Occupation } from '@/types/user'
import Form from '@/mixins/form'
import { isCordovaEnvironment } from '@/utils/cordova'

@Component({
  components: {
    WorkerInfoInputGroup: () => import('./WorkerInfoInputGroup.vue'),
    WorkerInfoList: () => import('./WorkerInfoList.vue')
  }
})
export default class WorkerInfoForm extends mixins(Form) {
  @Prop({ type: Object }) workerInfo!: PrivateWorker
  @Prop({ type: Array }) occupations!: Occupation[]

  edditing = false
  $store!: ExStore
  inputs = { ...this.workerInfo }
  errorMessage = ''
  updatePending = false

  handleClickEdit() {
    const url = this.profileEditPath
    if (isCordovaEnvironment()) {
      this.$postMessage.openExternalUrl(url)
    } else {
      window.open(url, '_blank')
    }
  }

  get profileEditPath() {
    const manageUrl = getEnvVar('MANAGE_ENDPOINT')
    const heartlineId = this.$store.getters['user/userInfo']['heartlineId']
    const token = localStorage.getItem('token') || ''
    return `${manageUrl}accounts/contract_login/?heartline_id=${heartlineId}&access_token=${token}`
  }

  async handleClickSave() {
    if (this.updatePending) {
      return
    }

    this.updatePending = true
    this.errorMessage = ''

    if (this.validator.hasAnyError()) {
      this.updatePending = false
      this.errorMessage = '入力項目に誤りがあります。'
      return
    }

    try {
      await this.$store.dispatch('user/patchWorkerInfo', this.inputs)

      this.inputs = {
        ...(this.$store.getters['user/workerInfo'] as PrivateWorker)
      }

      this.$store.dispatch('user/updateUserInfo')
    } catch (error) {
      //
    } finally {
      this.updatePending = false
      this.edditing = false
    }
  }
}
